import { render, staticRenderFns } from "./TabNaviEntryTemplate.vue?vue&type=template&id=539b0e21&"
import script from "./TabNaviEntryTemplate.vue?vue&type=script&lang=ts&"
export * from "./TabNaviEntryTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports